<template>
  <div class="your-detail__container">
    <BaseButton
      text="Back to 'Cover details'"
      flat
      ripple
      class="font-weight-semi-bold d-flex back-btn back-previous__btn-link pa-0 mb-sm-5"
      icon="mdi-chevron-left"
      color="#106175"
      small
      @click="backToCoverType"
    />
    <v-row class="mb-5">
      <v-col class="d-flex justify-space-between flex-wrap section-title">
        <div>
          <h1 class="font-28 font-weight-bold black2-color">Your details</h1>
        </div>
        <BaseButton
          :text="$vuetify.breakpoint.lgAndUp ? 'Save &amp; exit' : 'Save'"
          flat
          depressed
          ripple
          class="font-weight-semi-bold d2c-save-exit mt-2 py-3 d-flex"
          icon="mdi-content-save"
          color="#106175"
          small
          @click="handleSaveAndExit()"
        />
      </v-col>
    </v-row>
    <ValidationObserver ref="observerFormDetails">
      <v-form ref="submitForm">
        <BaseLabel class="mb-2" :text="LABEL_CONSTANTS.TITLE_LABEL" />
        <BaseSelect
          v-model="questionApplicant1Title.Value"
          :items="applicant1TitleOptions"
          :data-uiid="questionApplicant1Title.InterfaceKey"
          :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
          :isEnableSortOrderListItems="false"
          :rules="{
            required: {
              required: true,
              fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '280px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="Title"
        />

        <BaseLabel
          class="mt-10 mb-2"
          :text="LABEL_CONSTANTS.FIRST_NAME_LABEL"
        />
        <BaseInput
          hideDetails="auto"
          vid="Applicant1Forename"
          v-model="questionApplicant1Forename.Value"
          :data-uiid="questionApplicant1Forename.InterfaceKey"
          :rules="applicantFirstNameRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="First name"
        />

        <BaseLabel class="mt-10 mb-2" text="Surname" />
        <BaseInput
          hideDetails="auto"
          vid="Applicant1Surname"
          v-model="questionApplicant1Surname.Value"
          :data-uiid="questionApplicant1Surname.InterfaceKey"
          :rules="applicantLastNameRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="Surname"
        />

        <BaseLabel
          class="mt-10 mb-2"
          :text="LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL"
          label-class="font-18 font-weight-medium mb-1"
        />
        <BaseInputDate
          hideDetails="auto"
          vid="Applicant1DoB"
          :data-uiid="questionApplicant1DoB.InterfaceKey"
          :value="questionApplicant1DoB.Value"
          v-model="questionApplicant1DoB.Value"
          :rules="applicantDateOfBirthRules"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="Date of birth"
        />

        <BaseLabel
          class="mt-10 mb-2"
          text="Occupation"
          helpText="Please select your occupation, if you cannot find an exact match for your occupation then please select the closest match."
        />
        <BaseAutocomplete
          vid="Applicant1Occupation"
          v-model="questionApplicant1Occupation.Value"
          :data-uiid="questionApplicant1Occupation.InterfaceKey"
          :items="allOccupations"
          placeholder="Start typing…"
          :noDataMatchingMessage="LABEL_CONSTANTS.NO_MATCHING_DATA_OCCUPATION"
          :rules="{
            required: {
              required: true,
              fieldLabel: 'Occupation',
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="Occupation"
        />

        <BaseLabel
          class="mt-10 mb-2"
          text="Industry"
          helpText="Please select your industry, if you cannot find an exact match for your industry then please select the closest match."
        />
        <BaseAutocomplete
          vid="Applicant1Industry"
          v-model="questionApplicant1Industry.Value"
          :data-uiid="questionApplicant1Industry.InterfaceKey"
          :items="allIndustries"
          placeholder="Start typing…"
          :noDataMatchingMessage="LABEL_CONSTANTS.NO_MATCHING_DATA_INDUSTRY"
          :rules="{
            required: {
              required: true,
              fieldLabel: 'Industry',
            },
          }"
          :style="{
            'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
          }"
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          aria-label="Industry"
        />

        <BaseToggle
          class="mt-10"
          label="Add second applicant?"
          v-model="questionSecondApplicantIncluded.Value"
          pslStyle="button"
          :data-uiid="questionSecondApplicantIncluded.InterfaceKey"
          aria-label="Add second applicant"
        />

        <template v-if="questionSecondApplicantIncluded.Value">
          <BaseLabel class="mt-10 mb-2" :text="LABEL_CONSTANTS.TITLE_LABEL" />
          <BaseSelect
            vid="Applicant2Title"
            v-model="questionApplicant2Title.Value"
            :items="applicant2TitleOptions"
            :data-uiid="questionApplicant2Title.InterfaceKey"
            :selectedDefault="LABEL_CONSTANTS.SELECT_DEFAULT_PLACEHOLDER"
            :isEnableSortOrderListItems="false"
            :rules="{
              required: {
                required: true,
                fieldLabel: LABEL_CONSTANTS.TITLE_LABEL,
              },
            }"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '280px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            aria-label="Title"
          />

          <BaseLabel
            class="mt-10 mb-2"
            :text="LABEL_CONSTANTS.FIRST_NAME_LABEL"
          />
          <BaseInput
            hideDetails="auto"
            vid="Applicant2Forename"
            v-model="questionApplicant2Forename.Value"
            :data-uiid="questionApplicant2Forename.InterfaceKey"
            :rules="applicantFirstNameRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            aria-label="First name"
          />

          <BaseLabel class="mt-10 mb-2" text="Surname" />
          <BaseInput
            hideDetails="auto"
            vid="Applicant2Surname"
            v-model="questionApplicant2Surname.Value"
            data-uiid="Applicant2Surname"
            :rules="applicantLastNameRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            aria-label="Surname"
          />

          <BaseLabel
            class="mt-10 mb-2"
            :text="LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL"
            label-class="font-18 font-weight-medium mb-1"
          />
          <BaseInputDate
            hideDetails="auto"
            Date
            vid="Applicant2DoB"
            :data-uiid="questionApplicant2DoB.InterfaceKey"
            :value="questionApplicant2DoB.Value"
            v-model="questionApplicant2DoB.Value"
            :rules="applicantDateOfBirthRules"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            aria-label="Date of birth"
          />

          <BaseLabel
            class="mt-10 mb-2"
            text="Occupation"
            helpText="Please select your occupation, if you cannot find an exact match for your occupation then please select the closest match."
          />
          <BaseAutocomplete
            vid="Applicant2Occupation"
            :data-uiid="questionApplicant2Occupation.InterfaceKey"
            :items="allOccupations"
            v-model="questionApplicant2Occupation.Value"
            placeholder="Start typing…"
            :noDataMatchingMessage="LABEL_CONSTANTS.NO_MATCHING_DATA_OCCUPATION"
            :rules="{
              required: {
                required: true,
                fieldLabel: 'Occupation',
              },
            }"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            aria-label="Occupation"
          />

          <BaseLabel
            class="mt-10 mb-2"
            text="Industry"
            helpText="Please select your industry, if you cannot find an exact match for your industry then please select the closest match."
          />
          <BaseAutocomplete
            vid="Applicant2Industry"
            v-model="questionApplicant2Industry.Value"
            :data-uiid="questionApplicant2Industry.InterfaceKey"
            :items="allIndustries"
            placeholder="Start typing…"
            :noDataMatchingMessage="LABEL_CONSTANTS.NO_MATCHING_DATA_INDUSTRY"
            :rules="{
              required: {
                required: true,
                fieldLabel: 'Industry',
              },
            }"
            :style="{
              'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
            }"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
            aria-label="Industry"
          />
        </template>

        <BaseLabelDialog
          class="mt-10 mb-2"
          text="For the cover required have you or any member of your family made any claim in the last 5 years?"
          helpText="Please advise, for each claim made in the last 5 years, the following information: <ul><li>Claim under Buildings or Contents</li><li>The month and year of the claim</li><li>The amount of the claim</li><li>Type of claim</li></ul>Where any claim has occurred in the last 5 years, please provide further details."
        />
        <BaseToggleButton
          :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '120' : ''"
          v-model="questionPreviousClaim.Value"
          pslStyle="button"
          :data-uiid="questionPreviousClaim.InterfaceKey"
          :toggleButtonText="{
            yesDataUiid: `${questionPreviousClaim.InterfaceKey}_Yes`,
            noDataUiid: `${questionPreviousClaim.InterfaceKey}_No`,
          }"
          aria-label="For the cover required have you or any member of your family made any claim in the last 5 years?"
        />
      </v-form>
    </ValidationObserver>
    <template v-if="questionPreviousClaim.Value">
      <div class="mt-10">
        <BaseAlert
          v-if="!isClaimFormValid"
          color="#fbecec"
          alertText="Please add your details of your claim below."
          alertTextClass="black--text font-16"
          icon="mdi-alert-circle"
          class="field-invalid v-messages error--text"
          iconColor="var(--red-500)"
        />

        <PreviousClaimsForm
          :hideDetails="false"
          @add-table-items="addTableItems"
          @remove-table-items="removeTableItems"
        />
      </div>
    </template>

    <v-row class="mt-2">
      <v-col class="d-flex">
        <BaseButton
          :text="`${
            $vuetify.breakpoint.lgAndUp
              ? 'CONTINUE TO PROPERTY DETAILS'
              : 'CONTINUE'
          }`"
          rounded
          class="font-weight-bold continue-button"
          height="60"
          :color="'psorange'"
          :textColor="'#000000'"
          :fontSize="'font-20'"
          @click="onSubmit"
          :min-width="$vuetify.breakpoint.lgAndUp ? '450' : '100%'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  scrollTop,
  addFieldLabel,
  convertToBool,
  tryGoToNextStep,
} from "@/common/utils";
import { EventBus } from "@/common/eventbus.js";
import { ValidationObserver } from "vee-validate";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { populateClaimTable } from "@/common/claims";

import {
  setItemDataUiids,
  APPLICANT_TITLE_ITEMS_PLUS_MX,
} from "@/constants/component.constants";
import { AMOUNT_DEFAULT_FORMAT } from "@/constants/currency-format.constants";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import {
  ERROR_INVALID,
  ERROR_NAME_INVALID,
  ERROR_MSG_MAX_CHARACTER,
  ERROR_MSG_MAX_CHARACTER_COST_CLAIM,
  ERROR_PREVIOUS_INVALID_CLAIM_AMOUNT,
  ERROR_PREVIOUS_INVALID_FIVE_YEAR_DATE,
} from "@/constants/message.constants.js";
import {
  DATE_REGEX,
  NAME_REGEX,
  FIRST_NUMBER_CHARACTERS_REGEX,
} from "@/constants/regex-patterns.constants";
import { ROUTE_NAME } from "@/constants/route.constants";
import { DIALOG_MODULE, QUESTIONS_MODULE } from "@/store/types/module-types";

import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
import BaseLabelDialog from "@/components/BaseComponents/BaseLabelDialog.vue";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseSelect from "@/components/BaseComponents/BaseSelect.vue";
import BaseToggle from "@/components/BaseComponents/BaseToggle.vue";
import BaseInputDate from "@/components/BaseComponents/BaseInputDate.vue";
import BaseAutocomplete from "@/components/BaseComponents/BaseAutocomplete.vue";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton.vue";
import PreviousClaimsForm from "@/components/Forms/PreviousClaimsForm";
import BaseAlert from "@/components/BaseComponents/BaseAlert";
export default {
  components: {
    ValidationObserver,
    BaseButton,
    BaseInputDate,
    BaseAutocomplete,
    BaseInput,
    BaseLabel,
    BaseSelect,
    BaseToggle,
    BaseToggleButton,
    PreviousClaimsForm,
    BaseAlert,
    BaseLabelDialog,
  },
  data() {
    return {
      questionApplicant1DoB: {},
      questionApplicant1Forename: {},
      questionApplicant1Surname: {},
      questionApplicant1Title: {},
      questionApplicant1Occupation: {},
      questionApplicant1Industry: {},
      questionSecondApplicantIncluded: {},
      questionApplicant2DoB: {},
      questionApplicant2Forename: {},
      questionApplicant2Surname: {},
      questionApplicant2Title: {},
      questionApplicant2Occupation: {},
      questionApplicant2Industry: {},
      questionPreviousClaim: {},
      repeatingGroupPreviousClaim: {},
      NAME_REGEX,
      FIRST_NUMBER_CHARACTERS_REGEX,
      DATE_REGEX,
      AMOUNT_DEFAULT_FORMAT,
      LABEL_CONSTANTS,
      ERROR_PREVIOUS_INVALID_FIVE_YEAR_DATE,
      ERROR_PREVIOUS_INVALID_CLAIM_AMOUNT,
      ERROR_NAME_INVALID,
      ERROR_MSG_MAX_CHARACTER,
      ERROR_INVALID,
      ERROR_MSG_MAX_CHARACTER_COST_CLAIM,
      APPLICANT_TITLE_ITEMS_PLUS_MX,
      isClaimFormValid: true,
      applicantDateOfBirthRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          date_valid: {
            errorMessageTemplate: ERROR_INVALID,
          },
          regex: {
            errorMessageTemplate: ERROR_INVALID,
            pattern: DATE_REGEX,
          },
          age_in_range: {
            min: 18,
            max: 120,
          },
        },
        LABEL_CONSTANTS.DATE_OF_BIRTH_LABEL
      ),
      applicantFirstNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 50,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        LABEL_CONSTANTS.FIRST_NAME_LABEL
      ),
      applicantLastNameRules: addFieldLabel(
        {
          required: {
            required: true,
          },
          max: {
            length: 100,
            errorMessageTemplate: ERROR_MSG_MAX_CHARACTER,
          },
          min_length: {
            length: 2,
          },
          regex: {
            pattern: NAME_REGEX,
            customMessage: ERROR_NAME_INVALID,
          },
        },
        "Surname"
      ),
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, [
      "quoteResponse",
      "questionMap",
      "restoringLastStep",
    ]),
    ...mapGetters(QUESTIONS_MODULE, [
      "isExpired",
      "allIndustries",
      "allOccupations",
      "repeatingQuestionSetIndex",
    ]),
    applicant1TitleOptions() {
      return setItemDataUiids(
        "Applicant1Title",
        this.APPLICANT_TITLE_ITEMS_PLUS_MX
      );
    },
    applicant2TitleOptions() {
      return setItemDataUiids(
        "Applicant2Title",
        this.APPLICANT_TITLE_ITEMS_PLUS_MX
      );
    },
    isNoClaimValid() {
      const hasClaimItems = this.repeatingGroupPreviousClaim?.Value?.length > 0;
      const hasPreviousClaim = !!this.questionPreviousClaim?.Value;
      return (
        (hasPreviousClaim && hasClaimItems) ||
        (!hasPreviousClaim && !hasClaimItems)
      );
    },
  },
  beforeMount() {
    this.onSetupAndLoadSavedData();
    scrollTop();
  },
  async mounted() {
    this.setCurrentRefObserverForm(this.$refs.observerFormDetails);
    if (!this.restoringLastStep) {
      return;
    }
    setTimeout(async () => {
      tryGoToNextStep(
        this.$refs.observerFormDetails,
        async (form) => (await form.validate()) && this.isNoClaimValid,
        ROUTE_NAME.HOME.B2B.PROPERTY_DETAILS
      );
    }, 0);
  },
  watch: {
    "quoteResponse.Answers"() {
      this.populateClaimsValue();
    },
    "questionPreviousClaim.Value"(value) {
      if (value !== undefined && !value) {
        this.isClaimFormValid = true;
        this.repeatingGroupPreviousClaim.Value = [];
        this.resetNoClaimsTable();
      }
    },
  },
  methods: {
    ...mapMutations(DIALOG_MODULE, ["showModal"]),
    ...mapActions(QUESTIONS_MODULE, [
      "saveProgress",
      "increaseRepeatingQuestionSetIndex",
      "setRestoringLastStep",
      "setupReceivePreviousClaimData",
      "preparePreviousClaimData",
      "setIsExpiredFlag",
      "toggleGlobalSaveAndExitDialog",
      "setCurrentRefObserverForm",
      "refreshSessionAndNextStep",
    ]),

    async onSetupAndLoadSavedData() {
      this.questionsPropertyStatus = this.questionMap.OwnershipProperty;
      this.questionResidentialStatus = this.questionMap.ResidentialStatus;
      this.questionUnapprovedMortgageApplication =
        this.questionMap.UnapprovedMortgageApplication;
      this.questionApplicant1DoB = this.questionMap.Applicant1DoB;
      this.questionApplicant1Forename = this.questionMap.Applicant1Forename;
      this.questionApplicant1Surname = this.questionMap.Applicant1Surname;
      this.questionApplicant1Title = this.questionMap.Applicant1Title;
      this.questionApplicant1Occupation = this.questionMap.Applicant1Occupation;
      this.questionApplicant1Industry = this.questionMap.Applicant1Industry;
      this.questionSecondApplicantIncluded =
        this.questionMap.SecondApplicantIncluded;
      this.questionSecondApplicantIncluded.Value = convertToBool(
        this.questionSecondApplicantIncluded.Value
      );
      this.questionApplicant2DoB = this.questionMap.Applicant2DoB;
      this.questionApplicant2Forename = this.questionMap.Applicant2Forename;
      this.questionApplicant2Surname = this.questionMap.Applicant2Surname;
      this.questionApplicant2Title = this.questionMap.Applicant2Title;
      this.questionApplicant2Occupation = this.questionMap.Applicant2Occupation;
      this.questionApplicant2Industry = this.questionMap.Applicant2Industry;
      this.repeatingGroupPreviousClaim =
        this.questionMap.RepeatingGroupPreviousClaim;
      this.questionPreviousClaim = this.questionMap.PreviousClaim;
      this.questionPreviousClaim.Value = convertToBool(
        this.questionPreviousClaim.Value
      );

      if (this.questionPreviousClaim?.Value === true) {
        this.populateClaimsValue();
      }
    },
    populateClaimsValue() {
      this.repeatingGroupPreviousClaim.Value = [];
      populateClaimTable(
        this.$store.state.questions,
        this.quoteResponse.Answers,
        this.repeatingGroupPreviousClaim
      );
    },
    async onSubmit() {
      const isValidForm = await this.$refs.observerFormDetails.validate();
      this.isClaimFormValid = !(
        this.questionPreviousClaim.Value &&
        !this.repeatingGroupPreviousClaim.Value?.length
      );
      if (!isValidForm || !this.isClaimFormValid) {
        setTimeout(() => {
          EventBus.$emit("validation-error", "Validation error occurred");
        }, 100);
        return;
      }

      this.setupSubmitApplicant2Data();
      sessionStorage.removeItem("isNewQuoteFromExpiredQuote");
      if (this.questionsPropertyStatus.Value !== "OwnedMortgaged") {
        this.questionResidentialStatus.Value = null;
        this.questionUnapprovedMortgageApplication.Value = null;
      }
      this.saveProgress();
      this.refreshSessionAndNextStep(ROUTE_NAME.HOME.B2B.PROPERTY_DETAILS);
    },

    setupSubmitApplicant2Data() {
      if (!this.questionSecondApplicantIncluded.Value) {
        this.questionApplicant2DoB.Value = null;
        this.questionApplicant2Forename.Value = null;
        this.questionApplicant2Surname.Value = null;
        this.questionApplicant2Title.Value = null;
        this.questionApplicant2Occupation.Value = null;
        this.questionApplicant2Industry.Value = null;
      }
    },

    handleSaveAndExit() {
      this.setupSubmitApplicant2Data();
      this.toggleGlobalSaveAndExitDialog();
    },

    backToCoverType() {
      this.$router.push({ name: ROUTE_NAME.HOME.B2B.COVER_TYPE });
    },
    addTableItems(tableItems) {
      this.repeatingGroupPreviousClaim.Value = tableItems;
    },
    removeTableItems(tableItems) {
      this.repeatingGroupPreviousClaim.Value = tableItems;
    },
    resetNoClaimsTable() {
      this.repeatingGroupPreviousClaim.Value = [];
    },
  },
};
</script>

<style lang="scss" scoped></style>
